// extracted by mini-css-extract-plugin
export var chBoxes = "style-mod--ch-boxes--3e42f";
export var chContent = "style-mod--ch-content--a1d6f";
export var chMedia = "style-mod--ch-media--9be99";
export var chMediaDesktop = "style-mod--ch-media-desktop--b3493";
export var chMediaMobile = "style-mod--ch-media-mobile--7f53f";
export var chText = "style-mod--ch-text--cc6d2";
export var chTitle = "style-mod--ch-title--df2b1";
export var contactHero = "style-mod--contact-hero--d1205";
export var contactHeroResonsive = "style-mod--contact-hero-resonsive--223b6";
export var contactUrl = "style-mod--contact-url--bf8eb";